import { useQuery } from "@tanstack/react-query";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";
import { useCurrency } from "@/context/CurrencyContext";

export const WinsTicker = () => {
  const { fmt } = useCurrency();
  const { data } = useQuery({ queryKey: ["wins"], queryFn: () => api.get("/feed/wins").then((r) => r.data), refetchInterval: 30000 });
  if (!data?.length) return null;
  const items = [...data, ...data];
  return (
    <div data-testid="wins-ticker" className="mb-4 flex items-center overflow-hidden rounded-lg border border-[#1E293B] bg-[#121824]">
      <span className="z-10 flex shrink-0 items-center gap-1.5 bg-[#10B981] px-3 py-2 font-display text-xs font-black uppercase text-[#0B0E14]">
        <Trophy className="h-3.5 w-3.5" /> Big wins
      </span>
      <div className="relative flex-1 overflow-hidden">
        <div className="ticker-track flex w-max gap-8 whitespace-nowrap px-4 py-2 text-xs">
          {items.map((w, i) => (
            <span key={i} className="text-slate-300">
              <span className="font-odds text-slate-400">{w.who}</span> won{" "}
              <span className="font-odds font-bold text-[#10B981]">{fmt(w.amount_usd)}</span> on {w.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
